"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Queue = /** @class */ (function () {
    function Queue() {
        this['[[QUEUE]]'] = [];
    }
    /**
     * 添加新的元素
     * @param val
     */
    Queue.prototype.add = function (val) {
        if (this['[[QUEUE]]'].indexOf(val) === -1) {
            this['[[QUEUE]]'].push(val);
        }
    };
    /**
     * 清空队列
     */
    Queue.prototype.clear = function () {
        this['[[QUEUE]]'].splice(0, this['[[QUEUE]]'].length);
    };
    /**
     * 遍历队列
     * @param callback
     */
    Queue.prototype.forEach = function (callback) {
        this['[[QUEUE]]'].forEach(callback);
    };
    return Queue;
}());
exports.default = Queue;



// WEBPACK FOOTER //
// ./src/queue.ts